"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Auth_1 = __importDefault(require("./Auth"));
const Category_1 = __importDefault(require("./Category"));
const Menu_1 = __importDefault(require("./Menu"));
const Merchant_1 = __importDefault(require("./Merchant"));
const MerchantPrinter_1 = __importDefault(require("./MerchantPrinter"));
const Order_1 = __importDefault(require("./Order"));
const AppOrder_1 = __importDefault(require("./AppOrder"));
const AppMenu_1 = __importDefault(require("./AppMenu"));
const PromoCode_1 = __importDefault(require("./PromoCode"));
const Logger_1 = __importDefault(require("./Logger"));
const Modifier_1 = __importDefault(require("./Modifier"));
const DeliveryOrder_1 = __importDefault(require("./DeliveryOrder"));
const Department_1 = __importDefault(require("./Department"));
const ApiOrder_1 = __importDefault(require("./ApiOrder"));
const CustomReason_1 = __importDefault(require("./CustomReason"));
const Device_1 = __importDefault(require("./Device"));
const Landing_1 = __importDefault(require("./Landing"));
exports.default = {
    auth: new Auth_1.default(),
    category: new Category_1.default(),
    menu: new Menu_1.default(),
    merchant: new Merchant_1.default(),
    merchantPrinter: new MerchantPrinter_1.default(),
    order: new Order_1.default(),
    appOrder: new AppOrder_1.default(),
    appMenu: new AppMenu_1.default(),
    promoCode: new PromoCode_1.default(),
    logger: new Logger_1.default(),
    modifier: new Modifier_1.default(),
    deliveryOrder: new DeliveryOrder_1.default(),
    department: new Department_1.default(),
    apiOrder: new ApiOrder_1.default(),
    customReason: new CustomReason_1.default(),
    device: new Device_1.default(),
    landing: new Landing_1.default(),
};
//# sourceMappingURL=index.js.map